import { styled } from '@engyalo/design-system';
import { css, Icon, Stack } from '@mui/material';

export const SettingsItemWrapper = styled(Stack)(
  ({ theme }) => css`
    background-color: ${theme.palette.background.paper};
    flex-direction: row;
    gap: 0.8rem;
    padding: 1.2rem;
    align-items: center;
    border-radius: 1rem;
  `
);

export const CustomIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.palette.primary.dark};
    font-size: 2.4rem;
  `
);
